import React, {Component} from 'react'
import _ from 'lodash';
import FormGroupSelectInput from "./formGroupSelectInput";
import Button from "./button";
import {connect} from 'react-redux';
import {requestGetGroupsOfSolicitors} from "../actions/groups";
import {changeAgentsListSettings} from "../actions/agentsList";
import {requestPatchExistingSolicitor} from "../actions/newSolicitor";
import { LEGAL_ADVICE_TEXT } from '../helpers/variables';

class ChangeSolicitorsLawsysAgent extends Component{

    componentWillMount() {
        this.props.requestGetGroupsOfSolicitors();
    }

    attachSolicitorFirm = (lawsys) => {
        let solicitorGroups = this.props.groups.solicitorGroups.data;
        let exists = false;

        loop:
            for (let i = 0; i < solicitorGroups.length; i++) {
                if (solicitorGroups[i].hasOwnProperty('solicitors')) {
                    for (let j = 0; j < solicitorGroups[i].solicitors.length; j++) {
                        if (solicitorGroups[i].solicitors[j].lawsysFirmId === parseInt(lawsys.lawsysId)) {
                            exists = true;
                            break loop
                        }
                    }
                }
            }

        if(exists){
            let solicitors = [];
            let selectedSolicitors = this.props.selectedSolicitorUsers;
            for (let index in selectedSolicitors) {
                this.props.requestPatchExistingSolicitor({lawsysId:this.props.selectedLawsysId, userId: selectedSolicitors[index].userId}, selectedSolicitors[index].userId)
            }
        }
        else this.props.changeAgentsListSettings('solicitorNotInGroup', true)
    };

    attachLawsysPayload = (props, selectedSolicitors, newLawsysId) => {
        let lawsysFirmIndex = _.findIndex(this.props.lawsysFirms.lawsysFirms, {id: parseInt(newLawsysId)});

        let solicitors = [];
        for (let index in selectedSolicitors) {
            solicitors.push(selectedSolicitors[index].username)
        }
        return {
            agentUserName: solicitors,
            lawsysId: newLawsysId,
            lawsysName: this.props.lawsysFirms.lawsysFirms[lawsysFirmIndex].name,
            addressLine1: this.props.lawsysFirms.lawsysFirms[lawsysFirmIndex].address,
            postcode: this.props.lawsysFirms.lawsysFirms[lawsysFirmIndex].postcode
        }
    };

    madeChanges = (lawsysFirms, newLawsys) => {
        let firm = lawsysFirms.lawsysFirms.filter(value => value.id === parseInt(newLawsys))[0];
        return firm.name;//TODO: make newLawsys int instead of string!
    };

    render(){


        let distinct = [];
        for (let index in this.props.AgentsList.selectedSolicitorUsers) {
            if (!distinct.includes(this.props.AgentsList.selectedSolicitorUsers[index].lawsysId)) {
                // distinct.push(this.props.calculateLawsysName(this.props.AgentsList.selectedSolicitorUsers[index].lawsysId))
                // distinct.push(' | ')
                distinct.push(
                    <ul className="unorderedListNoBulletsAndSpace" key={this.props.AgentsList.selectedSolicitorUsers[index].id}>
                        <li><b>{this.props.AgentsList.selectedSolicitorUsers[index].forename  + ' ' +  this.props.AgentsList.selectedSolicitorUsers[index].surname + ': '}</b><span>{this.props.calculateLawsysName(this.props.AgentsList.selectedSolicitorUsers[index].lawsysId)}</span></li>
                    </ul>
                )
            }
        }

        return (
            <div className="agentsList-confirm-changes-modal">
                {!this.props.AgentsList.displayConfirm ?
                    <div className="appFormRefSettings-modal-content">
                        <div className="appFormRefSettings-close-button" onClick={() => this.props.DisplayModal()}></div>
                        <h2 className="solicitor-form-modal-title">Change {LEGAL_ADVICE_TEXT}</h2>
                        <form className="form-horizontal">
                            <div className="form-group">
                                <label className="col-sm-3  control-label.text-left formGroupSelectInput-label">Existing
                                    Solicitor</label>
                                <div
                                    className="col-sm-9 solicitor-form-modal-lawsys-wrapper">{distinct.map(value => value)}</div>
                            </div>
                            <FormGroupSelectInput Label={`New ${LEGAL_ADVICE_TEXT}`} LeftWrapper="col-sm-3"
                                                  HandleInputChange={(evt) => this.props.SelectLawsysId({
                                                      allFirms: this.props.lawsysFirms.lawsysFirms,
                                                      id: evt.target.value
                                                  })}
                                                  Options={[{
                                                      key: '',
                                                      value: `Select ${LEGAL_ADVICE_TEXT}`
                                                  }, ...this.props.lawsysFirms.lawsysFirms.map((value) => {
                                                      return {key: value.id, value: value.name}
                                                  })]}
                                                  CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                                                  RightWrapper="" Required={false}
                                                  SelectStyle={'form-control agentList-formGroupSelectInput-select'}

                            />
                            <div className="form-group">
                                <div className="col-sm-3"></div>
                                <div className="col-sm-9 solicitor-form-modal-buttons-wrapper">
                                    <Button wrapper="btn-wrapper-forForms" clickHandler={() => this.props.DisplayConfirm()} btnType="button"  btnStyle={'btn btn-primary btn-xs sharp yellow'} label="Change Solicitor"/>
                                    <Button wrapper="btn-wrapper-forForms" clickHandler={() => this.props.DisplayModal()} btnType="button"  btnStyle={'btn btn-primary btn-xs sharp white'} label="Cancel"/>
                                </div>
                            </div>

                        </form>
                    </div>
                    :
                    <div className="appFormRefSettings-modal-content">
                        <div className="appFormRefSettings-close-button" onClick={() => this.props.DisplayModal()}></div>
                        <div className="form-group">
                            <div className="col-sm-12">
                                {distinct.map(value => value)}{' => '}{this.madeChanges(this.props.lawsysFirms, this.props.AgentsList.selectedLawsysId)}
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="col-sm-3">Confirm changes?</div>
                            <div className="col-sm-9 solicitor-form-modal-buttons-wrapper">
                                <Button wrapper="btn-wrapper" clickHandler={() => this.attachSolicitorFirm(this.attachLawsysPayload(this.props, this.props.AgentsList.selectedSolicitorUsers, this.props.AgentsList.selectedLawsysId))}
                                        btnType="button"  btnStyle={'btn btn-primary btn-xs sharp yellow'} label="Confirm"/>
                                <Button wrapper="btn-wrapper" clickHandler={() => this.props.DisplayModal()}
                                        btnType="button"  btnStyle={'btn btn-primary btn-xs sharp white'} label="Cancel"/>
                            </div>
                            {this.props.AgentsList.attachLawsysMsg}
                        </div>
                        {
                            this.props.AgentsList.solicitorNotInGroup ?
                                <div className="col-xs-12">
                                    <p>
                                        Selected {LEGAL_ADVICE_TEXT} does not belong to any {LEGAL_ADVICE_TEXT.toLowerCase()} group. Please create a new {LEGAL_ADVICE_TEXT.toLowerCase()} group containing the selected {LEGAL_ADVICE_TEXT.toLowerCase()} to proceed.
                                    </p>
                                    <div className="row">
                                        <div className="col-xs-12 ">
                                            <Button wrapper="btn-wrapper" clickHandler={() => this.props.changeAgentsListSettings('openNewSolicitorGroupModal', true)} btnType="button"  btnStyle={'btn btn-primary btn-xs sharp white'} label={`Create New ${LEGAL_ADVICE_TEXT} Group`}/>
                                        </div>
                                    </div>
                                </div>
                                :
                                null
                        }
                    </div>
                }
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    return {
        groups: state.groups
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        requestGetGroupsOfSolicitors: () => {
            dispatch(requestGetGroupsOfSolicitors())
        },
        changeAgentsListSettings: (key, value) => {
            dispatch(changeAgentsListSettings(key, value))
        },
        requestPatchExistingSolicitor: (solicitor, id) => {
            dispatch(requestPatchExistingSolicitor(solicitor, id))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeSolicitorsLawsysAgent);

